<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
                         :useBtnList="useBtnList"
                         :btnKey="useBtnListKey"
                         @btnPorSheet="btnPorSheet" @btnBomList="btnBomList" @btnRetrieve="btnRetrieve" @btnExcel="btnExcel"
                         :key="useBtnListKey"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12" class="px-1">
                  <i-label :label="'Basic Information : '"/>
                </v-col>
              </v-row>
              <v-row dense class="form-layout">
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="6">
                          <v-text-field class="quot-text-field" label="Quotation No." variant="outlined"
                              v-model="quotNo"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pl-2 pt-1 quotNo">
                          <v-select
                              v-model="quotStep"
                              :items="quotStepList"
                              item-value="value"
                              item-text="text"
                              label="Quotation Step"
                              return-object
                              single-line
                              outlined
                              dense
                              @change="quotNoChange"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Title</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                          v-model="headerData.quotTitle"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No, POR No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.shipPorNo"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Start Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.startDte"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Finish Time</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.finishDte"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Delivery Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.transCondDesc"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Payment Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.payCondDesc"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Purchase Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.buyerNm"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                  </v-row>
                  <!-- 수정 -->
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Recieve Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.receiveDte"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Submit Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          v-model="headerData.submitDte"
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                          dense
                          outlined
                          hide-details="auto"
                          readonly
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="px-1">
                  <i-label :label="'Detail Information : '"/>
                </v-col>
                <v-col cols="9" align="right" class="pa-1"  :style="headerData.receiveYn != null && headerData.receiveYn === 'Y' ? 'display: none;' : '' ">
                  <span class="pa-1 subTitle2">[Not yet Received]</span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                    <DxDataGrid id="epms6020"
                                class="hipGridHeight5"
                                :ref="epms6020Ref"
                                :data-source="dataList"
                                :remote-operations="false"
                                :hover-state-enabled="true"
                                :allow-column-resizing="true"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true"
                                :width="grid.width"
                                :show-row-lines="true"
                                key-expr="seq"
                                :focused-row-enabled="true"
                                :column-hiding-enabled="false"
                                :selection="{ mode: 'none' }"
                                @exporting="onExporting"                                   
                                        
                    >
                    <DxEditing :use-icons="true" />
                    <DxExport :enabled="true" />
                    <DxColumn data-field="seq" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="porNo" caption="Por No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlSpec" caption="Material Specification" width="30%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="reqQty" caption="Qty" width="5%" data-type="number" :format="format" alignment="right" :allow-editing="false" />
                    <DxColumn caption="Quotation Amount" data-type="string" alignment="center">
                      <DxColumn data-field="quotPrc" caption="Unit Price" width="8%" data-type="number" :format="format" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="quotAmt" caption="Amount" width="8%" data-type="number" :format="format" alignment="right" :allow-editing="false"/>
                      <DxColumn data-field="quotVat" caption="VAT(%)" width="4%" data-type="number" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Transportation Fee" data-type="string" alignment="center" >
                      <DxColumn data-field="transAmt" caption="Amount" width="8%" data-type="number"  :format="format" alignment="right" :allow-editing="false"/>
                      <DxColumn data-field="transVat" caption="VAT(%)" width="4%" data-type="number" alignment="right" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="govFee" width="5%" data-type="string" :format="format" alignment="right" :allow-editing="false" header-cell-template="govFeeTemplate"/>
                      <template #govFeeTemplate>
                        <div>Gov.Fee<br>(Price)</div>
                      </template>
                    <DxColumn data-field="canDelyDte" width="10%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false" header-cell-template="canDelyTemplate" />
                      <template #canDelyTemplate>
                        <div>Can Delivery<br>Date</div>
                      </template>
                    <DxColumn data-field="certYn" width="5%" data-type="number" alignment="center" :allow-editing="false" header-cell-template="certYnTemplate"/>
                      <template #certYnTemplate>
                        <div>Cert<br>Y/N</div>
                      </template>

                    <DxColumn caption="Maker Info." data-type="string" alignment="center" >
                        <DxColumn data-field="makerCd" caption="Code" width="4%" data-type="string"  :allow-editing="false"/>
                        <DxColumn data-field="makerNm" caption="Name" width="12%" data-type="string" :allow-editing="false"/>
                    </DxColumn>
                    <DxSummary>
                        <DxTotalItem column="shipNo" summary-type="count" display-format="SUM" />
                        <DxTotalItem column="quotAmt" summary-type="sum" :customize-text="totalFormatN0" />
                        <DxTotalItem column="transAmt" summary-type="sum" :customize-text="totalFormatN0" />
                    </DxSummary>

                    <DxPaging :enabled="true" :page-size="30" />

                  </DxDataGrid>
                  <div :style="headerData.filePath ? '' : 'display:none;' ">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" >View Attached File</span>
                  </div>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { getDwgCountByQuot, getRequestHead, getRequestDetail, goReceive, reportView, getPipeQuotYn } from '@/api/view/hip/common/common'
import epms101p from '@/views/hip/1/popup/epms101p'
import {epms6020, epms6020Detail} from "@/api/view/hip/I/epms6020";
import {getDateFormat, getNumComma} from "@/utils/common";
import DxDateBox from 'devextreme-vue/date-box'
import {DxExport } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter' ;


export default {
  name: 'epms6020',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox ,
    DxExport
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms6020Ref: 'epms6020Ref',
      quotStepList: [],

      quotNo : this.$route.params.quotNo,
      quotStep : "",

      headerData: {},
      dataList : [],
      useBtnList: ['btnRetrieve', 'btnPorSheet', 'btnBomList', 'btnExcel' ],
      useBtnListKey : 0,
      format: '#,##0.############',
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms6020Ref)
    },
  },
  methods: {
    totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
    },
    totalFormatN0(e) {
        const result = getNumComma(Number(e.value.toFixed(0)))
        return result
    },
    quotNoChange(e) {

    },
    btnPorSheet() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
      }

      this.openLoading('searching')
      reportView(param)
          .finally(() => {
            this.endLoading()
          })
    },
    btnExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('sheet');

        exportDataGrid({
            component: this.gridInstance,
            worksheet,
            topLeftCell: { row: 4, column: 1 },
        }).then((cellRange) => {

        // // header
        // const titleRow = worksheet.getRow(2);
        // titleRow.height = 30;
        // worksheet.mergeCells(2, 1, 2, 23);

        // titleRow.getCell(1).value = 'Angle Cutting Progress Status (Deahyup VN)';
        // titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
        // titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' };

        // condition
        const condRow = worksheet.getRow(1);
        condRow.height = 20;
        worksheet.mergeCells(3, 1, 3, 16);

        let strCond = 'Quotation No.: ' + this.quotNo + '  / Step: ' + this.quotStep.text;
        condRow.getCell(1).value = strCond;
        condRow.getCell(1).font = { name: 'Calibri', size: 12, bold: true };
        condRow.getCell(1).alignment = { horizontal: 'left' , vertical: 'middle' } ;

        const headerRow = worksheet.getRow(1);
        const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
        let headerRowLength = headerRow._cells.length        

        for(let i = 2; i <= headerRowLength; i++){
            headerRow.getCell(i).fill = headerStyle
            headerRow.getCell(i).border = headerBorderStyle
            headerRow.getCell(i).alignment = { horizontal: 'center', vertical: 'middle' }
        }
        for(let j = 2; j <= worksheet._rows.length; j++){
            for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){

                if (j == 2 || j == 3) {
                    worksheet.getRow(j).getCell(a).fill = headerStyle
                }

                worksheet.getRow(j).getCell(a).border = headerBorderStyle
                
                // if(worksheet.getColumn(a).dataField == "useQty" || worksheet.getColumn(a).dataField == "woQty") {
                //     worksheet.getRow(j).getCell(a).format = "#,###"
                //     worksheet.getRow(j).getCell(a).alignment = { horizontal: 'right' }
                // }
            }
        }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'SummitRessult.xlsx');
            });
        });     

        this.gridMainInstance.cancel = true;
    },  
    btnBomList() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
      }

      this.openLoading('searching')
      reportView(param)
          .finally(() => {
            this.endLoading()
          })
    },
    async btnRetrieve() {
      if(this.quotNo === '' || this.quotNo === null || this.quotNo === undefined)
        return;

      this.openLoading('searching')
      let loadingCnt = 2;
      let params = {
        makerCd: this.$store.state.user.makerCd,
        quotNo : this.quotNo,
        quotStep : this.quotStep.value,
      }
console.log('==================')
      console.log(params)

      await epms6020(params).then(res => {
        if(res.list.length > 0) {
          this.headerData = res.list[0]
        }
      }).finally(() => {
        loadingCnt--;
        if(loadingCnt === 0)
          this.endLoading()
      })


      await epms6020Detail(params).then(res => {
        this.dataList = res.list
      }).finally(() => {
        loadingCnt--;
        if(loadingCnt === 0)
          this.endLoading()
      })

    },

    getDateFormat(date) {
      return getDateFormat(date)
    },

    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px 8px'
      }
    }
  },
  mounted() {

    this.quotStepList.push({ value: 'A1', text : 'A1.Quotation'})
    this.quotStepList.push({ value: 'A2', text : 'A2.1st re-Quotation'})
    this.quotStepList.push({ value: 'A3', text : 'A3.2nd re-Quotation'})
    this.quotStepList.push({ value: 'A4', text : 'A4.3rd re-Quotation'})
    this.quotStepList.push({ value: 'B1', text : 'B1.P/I'})
    this.quotStepList.push({ value: 'C1', text : 'C1.Bidding'})
    this.quotStepList.push({ value: 'C2', text : 'C2.1st re-Bidding'})
    this.quotStepList.push({ value: 'C3', text : 'C3.2nd re-Bidding'})
    this.quotStepList.push({ value: 'C4', text : 'C4.3rd re-Bidding'})

    let setVal = this.quotStepList.find(element => element.value === this.$route.params.quotStep)

    if(!setVal)
      setVal = this.quotStepList[0];
    this.quotStep = setVal

    this.btnRetrieve();
  }
}
</script>
<style lang="scss" scoped>
$redBtn: #FF0000;
$blueBtn: #0000FF;

.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;

  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  // border: 1px solid gray;
  color: black;
  font-size: 9pt;
}
.quot-text-field{
  margin-top : 0px !important;
  padding-top: 0px !important;
  text-align: center;
}
.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}
.drawing {
  font-size: 10pt;
  color: black;
  cursor: pointer;
}
.drawing:hover{
  color: #4980BC;
}
.grd-btn {
  text-transform: unset !important;
  font-weight: bold;
  // height: 16px !important;

  :hover  {
    color: #4980BC;
  }
}

::v-deep {
  [role=btnReceiptRequest] {
    :not([disabled=disabled]) {
      .v-btn__content {
        div, i {
          color: #{$redBtn} !important;
        }
      }
    }
  }
}

::v-deep {
  [role=btnPrintRequest], [role=btnPrintRequestVn] {
    .v-btn__content {
      div, i {
        color: #{$blueBtn} !important;
      }
    }
  }
}
</style>